var render, staticRenderFns
import script from "./ScrollView.vue?vue&type=script&lang=ts&"
export * from "./ScrollView.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=cd4e94c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e94c0",
  null
  
)

export default component.exports